// MaterialUi
import React, { useEffect, useState } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';
import IconButtonClose from './../IconButtons/IconButtonClose';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';

export const Modal = (props) => {
    useEffect(() => {
        document.body.style.overflow = props.visible ? 'hidden' : 'unset';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [props.visible]);

    if (!props.visible) {
        return null;
    }

    return (
        <div className="modalFixedBg" onClick={props.onClose}>
            <div className="modalFixedBg__inner" onClick={(e) => e.stopPropagation()}>
                <div className="modalClose">
                    <IconButtonClose onClick={props.onClose} />
                </div>

                <div className="modalContainer">
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export const ModalCallMe = (props) => {
    useEffect(() => {
        document.body.style.overflow = props.visible ? 'hidden' : 'unset';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [props.visible]);

    if (!props.visible) {
        return null;
    }

    return (
        <div className="modalFixedBg-callMe" onClick={props.onClose}>
            <div className="modalFixedBg-callMe__inner" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className="modalFixedBg-callMe__modalClose"
                    onClick={props.onClose}
                >
                    X
                </button>

                <div className="modalFixedBg-callMe__modalContainer">
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export const MaterialInput = ({
    value,
    requiredColorRed,
    label,
    textLabelEmpty,
    noneRequiredColor,
    onChange,
    type,
    autocompletePassword,
    iconBlockPassword,
    blackText,
    onClickIcon,
    widthProps
}) => {
    const cleanValue = value ?? "";
    const [focus, setFocus] = useState(cleanValue !== "");
    const [touch, setTouch] = useState(false);

    useEffect(() => {
        setFocus(String(cleanValue).length > 0);
    }, [cleanValue]);

    const requiredColorClass = requiredColorRed ? "materialInput__required materialInput__required--danger" : "materialInput__required";

    return (
        <div
            className={`materialInput ${focus || cleanValue !== "" ? "materialInput--active" : ""} ${blackText ? "materialInput--darkText" : ""}`}
            style={{
                width: widthProps || undefined
            }}
        >
            <label className="materialInput__label">
                {label && textLabelEmpty ? label : `Введите ${label}`}
            </label>

            <div className="materialInput__field">
                <input
                    className="materialInput__input"
                    autoComplete={autocompletePassword ? "new-password" : ""}
                    type={type}
                    value={cleanValue}
                    onChange={onChange}
                    onFocus={() => {
                        setFocus(true);
                        setTouch(true);
                    }}
                    onBlur={(e) => {
                        if (e.target.value === "") {
                            setFocus(false);
                        } else {
                            setTouch(false);
                        }
                    }}
                />

                {iconBlockPassword && (
                    <button
                        type="button"
                        className="materialInput__iconBlockPassword"
                        onClick={onClickIcon}
                        aria-label="Показать пароль"
                    >
                        {type === "text" ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </button>
                )}
            </div>

            {!noneRequiredColor && touch && (
                <div className={requiredColorClass}>
                    {`Поле ${label} обязательно`}
                </div>
            )}
        </div>
    );
};

export const PersonalDataCheckbox = (props) => {
    const { data, setData, labelText } = props;

    const [checked, setChecked] = useState(data);

    const handleChange = (e) => {
        setData(e.target.checked);
        setChecked(e.target.checked);
    };

    return (
        <div
            className="checkboxText"
            style={{
                width: props.fullWidth ? "100%" : props.plus10W ? "110%" : "85%",
                margin: "0 auto",
                ...props.style,
            }}
        >
            <FormControlLabel
                style={{
                    marginLeft: "0"
                }}
                control={<Checkbox checked={checked} onChange={handleChange} />}
                label={labelText ? labelText : "Я ознакомлен(а) с Политикой конфиденциальности и даю согласие на обработку моих персональных данных. Я принимаю условия Пользовательского соглашения"}
            />
        </div>
    );
};

export const ButtonMaterialUi = (props) => {
    const onClick = () => {
        props.onClick && props.onClick();
    };

    return (
        <div className="text-center">
            <button
                type="button"
                disabled={props.BDisabled ? true : false}
                className="materialButton"
                onClick={onClick}
            >
                {props.icon && props.icon}
                {props.title && props.title}
            </button>
        </div>
    );
};

export const ButtonMaterialUiOval = (props) => {
    const onClick = () => {
        props.onClick && props.onClick();
    };

    return (
        <div>
            <button
                type="button"
                className="materialButtonOval"
                onClick={onClick}
            >
                {props.icon && props.icon}
                {props.title && props.title}
            </button>
        </div>
    );
};